<template>

  <div  v-if="!hideSearch" class="notify" :ref="'notice'+id" :style="'right:'+rightPad+'px'">
    
    <div @click="doClick" class="notifyIcon"></div>
    <div class="notifyText">
      <div>  {{searchText}}</div>
       <div v-if="!searching">{{notice.result}}</div>
     <div v-show="searching" class="scanSlot">
     
      <div class="scanSlotH" ></div>
       <div class="scanSlotV" ref="scanV"></div>
    </div>
    </div>
   </div>
 
</template>

<script>
import gsap from 'gsap'
export default {
  props: {
   notice:null,
   id:null
  },
  data() {
    return {
      searching:false,
      foundText:"Dr Fred McFredFace",
      rightPad:-340,
    };
  },
  mounted(){
    this.doSearch()
    gsap.to(this,1,{rightPad:0})
    gsap.delayedCall(this.notice.time,this.doFind)
  },
  computed: {
   hideSearch(){
     if(this.searching && this.notice.hideSearch){
       return true
     }
   },
   searchText(){
     console.log("SEARCH TEXT",this.notice)
     if(this.searching){
       return this.notice.searchText || "Searching:"+this.notice.task
     }else{
       return this.notice.foundText || "Found:"+this.notice.task
     }
   }
     
  },
  methods: {
   doSearch(){
     this.searching=true
     // gsap.fromTo(this.$refs["notice"+this.id],1,{height:"10px"},{height:"60px"})
     gsap.to(this.$refs.scanV,2,{left:"100%",yoyoEase:true,repeat:-1,ease: "none"})
   },
   doFind(){
     this.searching=false
     gsap.killTweensOf(this.$refs.scanV)
     gsap.delayedCall(5,this.doClose)
   },
   doClose(){
     this.$emit("closePopUp")
   },
   doClick(){
     if(this.searching){
       
       //this.doFind()
     }else{
       //this.doSearch()
     }
   }

  },
  beforeDestroy(){
    gsap.killTweensOf(this.doClose)
  }
};
</script>

<style lang="scss" scoped>
 @import "@/assets/sass/variables.scss";
//$border-blue:#00bbff;
.notifications{
   position:absolute;
  top:0px;
  right:0px;
  overflow:hidden;
}
.notify {
  margin-top:3px;
  width: 440px;
  height:60px;
  position:relative;
  border: solid 3px $glow-colour;
  border-right:0px;
  background-color: $glow-bg;
  box-shadow: inset 0px 0px 20px 0px;
  font-family: "Orbitron";
  font-size: 18px;
  color: $glow-colour;
  display:flex;
  line-height: 24px;
  cursor: pointer;
  text-transform: uppercase;
  border-radius:10px 0px 0px 10px;
  z-index: 999;
}
.notifyIcon {
  left:0px;
  width:60px;
  height:60px;
  background-image:url('../assets/images/experts/assistant.png');
  display:inline-block;
  background-size: cover;
   border-radius:10px 0px 0px 10px;
}
.notifyText{
   display:inline-block;
   text-align: left;
   padding:3px 7px;
   text-transform: none;
   width: calc(100% - 70px);
}
.scanSlot{
  margin-top:2px;
  width:100%;
  height:20px;
  position:relative;
  
}
.scanSlotH{
  width:100%;
  height:3px;
  background-color: $glow-colour;
  position:absolute;
  top:50%;
}
.scanSlotV{
  width:5px;
  height:16px;
  background-color: $glow-colour;
  position:absolute;
  left:0%;
  top:2px;
}

</style>
